<div class="right-side p-5">
  <div class="section">
    <div class="bkgimage">
      <form [formGroup]="invoiceForm" (ngSubmit)="onSubmit()" *ngIf="!loadStatus">
        <div class="row">

          <div class="col-12 text-center mb-4">
            <h3>Invoice Calculation Section</h3>
          </div>

          <div class="col-md-6">

            <div class="mb-3">
              <label for="date">Date : <span class="text-danger">*</span></label>
              <input type="text" class="form-control date"
                     matInput
                     [matDatepicker]="startPicker"
                     (focus)="startPicker.open()"
                     formControlName="date"
                     required
                     (keydown)="blockManualInput($event)" />
              <mat-datepicker #startPicker></mat-datepicker>
              <div *ngIf="invoiceForm.controls['date'].invalid && invoiceForm.controls['date'].touched" class="alert alert-danger">
                Date is required.
              </div>
            </div>

            <div class="mb-3">
              <label for="intervention">Intervention : <span class="text-danger">*</span></label>
              <input class="form-control" type="text" id="intervention" formControlName="intervention" required />
              <div *ngIf="invoiceForm.controls['intervention'].invalid && invoiceForm.controls['intervention'].touched" class="alert alert-danger">
                Intervention is required.
              </div>
            </div>

            <div class="mb-3">
              <label for="ratePerMSME">Rate per MSME (in ₹) : <span class="text-danger">*</span></label>
              <input class="form-control" type="number" id="ratePerMSME" formControlName="ratePerMSME" required />
              <div *ngIf="invoiceForm.controls['ratePerMSME'].invalid && invoiceForm.controls['ratePerMSME'].touched" class="alert alert-danger">
                Rate per MSME is required.
              </div>
            </div>

            <div class="mb-3">
              <label for="total">Total (in ₹) :</label>
              <input class="form-control" type="text" id="total" formControlName="total" />
            </div>

            <div class="mb-3">
              <label for="gstType">GST Type :</label>
              <input class="form-control" type="text" id="gstType" formControlName="gstType" required />
              <div *ngIf="invoiceForm.controls['gstType'].invalid && invoiceForm.controls['gstType'].touched" class="alert alert-danger">
                GST Type is Required
              </div>
            </div>

            <div class="mb-3">
              <label for="gstPercent">GST (in %) :</label>
              <input class="form-control" type="text" id="gstPercent" formControlName="gstPercent" />
            </div>

            <div class="mb-3">
              <button class="btn btn-success me-2" type="button" (click)="onCalculateGSTClick()"> Calculate Total GST </button>
            </div>

            <div class="mb-3">
              <label>Total GST (in ₹) : </label>
              <input class="form-control" type="text" id="totalGST" formControlName="totalGST" />
            </div>

            <div class="mb-3">
              <label>Final Total (in ₹) :</label>
              <input class="form-control" type="text" id="finalTotal" formControlName="finalTotal" />
            </div>

          </div>

          <div class="col-md-6">

            <div class="mb-3">
              <label for="eventName">Event Name : <span class="text-danger">*</span></label>
              <input class="form-control" type="text" id="eventName" formControlName="eventName" required />
            </div>

            <div class="mb-3">
              <label for="component">Component : <span class="text-danger">*</span></label>
              <textarea id="component" formControlName="component" class="form-control"></textarea>
            </div>

            <div class="mb-3">
              <label for="noOfMSMEAttended">No. of MSME Attended : <span class="text-danger">*</span></label>
              <div class="d-flex align-items-center">
                <input class="form-control me-2" type="number" id="noOfMSMEAttended" formControlName="noOfMSMEAttended" required />
                <button class="btn btn-outline-primary" type="button"
                        (click)="verifyMSMEEligibility()"
                        [disabled]="!eventId || isVerifyingMSME || isMSMEVerified">
                  <span *ngIf="isVerifyingMSME" class="spinner-border spinner-border-sm me-1"></span>
                  <span *ngIf="!isVerifyingMSME">Verify MSME</span>
                </button>
              </div>
            </div>

            <div class="mb-3 border rounded mt-4">
              <label style="padding: 6px;"> Unverified MSME : {{ unVerified }} </label>
            </div>

            <div class="mb-3 border rounded mt-4">
              <label style="padding: 6px;"> Eligible : {{ verified }} </label>
            </div>

            <div class="mb-3 border rounded mt-4">
              <label style="padding: 6px;"> NonEligible : {{ nonEligible }} </label>
            </div>

            <div class="mb-3">
              <label for="uploadInvoice">Upload Invoice : <span class="text-danger">*</span></label>
              <input type="file" id="uploadInvoice" (change)="onFileSelect($event)" formControlName="uploadInvoice" class="form-control" required />
              <div *ngIf="uploadError" class="alert alert-danger">{{ uploadError }}</div>
            </div>

          </div>
        </div>

        <div class="text-center mt-4">
          <!--<button class="btn btn-success me-2" type="submit" [disabled]="invoiceForm.invalid">Submit</button>-->
          <button class="btn btn-success me-2" type="submit" [disabled]="invoiceForm.invalid || isSubmitting || !isMSMEVerified || !documentUploaded || !calculationDone">
            {{ isSubmitting ? 'Submit' : 'Submit' }}
          </button>
          <button class="btn btn-danger" type="reset" (click)="onCancel()">Back</button>
        </div>
      </form>

      <form [formGroup]="invoiceStatusForm" *ngIf="loadStatus">

        <!-- ================= Invoice Details ================= -->
        <div class="row mb-4">
          <div class="col-12 text-center">
            <h3>Invoice Details Submitted</h3>
          </div>
        </div>

        <div class="row">

          <!-- LEFT COLUMN -->
          <div class="col-md-6">

            <div class="mb-3">
              <label>Event ID :</label>
              <input class="form-control" type="text" formControlName="eventId">
            </div>

            <div class="mb-3">
              <label>Event Name :</label>
              <input class="form-control" type="text" formControlName="eventName">
            </div>

            <div class="mb-3">
              <label>Intervention :</label>
              <input class="form-control" type="text" formControlName="intervention">
            </div>

            <div class="mb-3">
              <label>Component :</label>
              <input class="form-control" type="text" formControlName="component">
            </div>

            <div class="mb-3">
              <label>Event Status :</label>
              <input class="form-control" type="text" formControlName="eventStatus">
            </div>

            <div class="mb-3">
              <label>Invoice ID :</label>
              <input class="form-control" type="text" formControlName="invoiceID">
            </div>

            <div class="mb-3">
              <label>Date :</label>
              <input class="form-control" type="date" formControlName="date">
            </div>

          </div>

          <!-- RIGHT COLUMN -->
          <div class="col-md-6">

            <div class="mb-3">
              <label>Rate per MSME (₹) :</label>
              <input class="form-control" type="text" formControlName="ratePerMSME">
            </div>

            <div class="mb-3">
              <label>No. of MSME Attended :</label>
              <input class="form-control" type="text" formControlName="noOfMSMEAttended">

              <!--<div class="mt-2 small">
      <div>Verified MSME : <b>{{ verified }}</b></div>
      <div>Unverified MSME : <b>{{ unVerifiedMSMECount }}</b></div>
      <div>NonEligible MSME : <b>{{ nonEligible }}</b></div>
    </div>-->
            </div>

            <div class="mb-3">
              <label> Unverified MSME : {{ unVerifiedMSMECount }} </label>
            </div>

            <div class="mb-3">
              <label> Eligible : {{ verified }} </label>
            </div>

            <div class="mb-3">
              <label> NonEligible : {{ nonEligible }} </label>
            </div>

            <div class="mb-3">
              <label>Total (₹) :</label>
              <input class="form-control" type="text" formControlName="total">
            </div>

            <div class="mb-3">
              <label>GST Type :</label>
              <input class="form-control" type="text" formControlName="gstType">
            </div>

            <div class="mb-3">
              <label>GST Percent (%) :</label>
              <input class="form-control" type="text" formControlName="gstPercent">
            </div>

            <div class="mb-3">
              <label>Total GST (₹) :</label>
              <input class="form-control" type="text" formControlName="totalGST">
            </div>

            <div class="mb-3">
              <label>Final Total (₹) :</label>
              <input class="form-control" type="text" formControlName="finalTotal">
            </div>

            <!-- Invoice File Actions -->
            <div class="mb-3">
              <label class="d-block mb-2">Invoice File :</label>

              <button class="btn btn-warning btn-sm me-2"
                      type="button"
                      (click)="onDownloadInvoice()">
                <i class="bi bi-download"></i> Download
              </button>

              <button class="btn btn-info btn-sm"
                      type="button"
                      (click)="openFilePreviewDialog()">
                View File
              </button>
            </div>

          </div>

        </div>


        <!-- ================= Payment Details ================= -->
        <div class="row mt-5">

          <div class="col-12 text-center mb-3">
            <h3>Payment Details By MSSIDC</h3>
          </div>

          <div class="col-md-6">

            <div class="mb-3">
              <label>Invoice Status :</label>
              <input class="form-control" type="text" formControlName="statusName">
            </div>

            <div class="mb-3">
              <label>Invoice Accepted by MSSIDC :</label>
              <input class="form-control" type="text" formControlName="invoiceAccepted">
            </div>

            <div class="mb-3">
              <label>Payment Date :</label>
              <input class="form-control" type="date" formControlName="paymentDate">
            </div>

          </div>

          <div class="col-md-6">

            <div class="mb-3">
              <label>Payment Mode :</label>
              <input class="form-control" type="text" formControlName="paymentMode">
            </div>

            <div class="mb-3">
              <label>UTR Number :</label>
              <input class="form-control" type="text" formControlName="utrNumber">
            </div>

            <div class="mb-3">
              <label>Amount (₹) :</label>
              <input class="form-control" type="text" formControlName="amount">
            </div>

          </div>

        </div>


        <!-- ================= Buttons ================= -->
        <div class="text-center mt-4">
          <button class="btn btn-danger" type="button" (click)="onCancel()">Back</button>
        </div>

      </form>

    </div>
  </div>
</div>




<div class="section">

  <div class="row">
    <div class="text-end">
      <button (click)="exportToExcel()"
              type="button"
              class="btn btn-sm btn-success me-2">
        <i class="bi bi-file-earmark-excel"></i> Export To Excel
      </button>
    </div>
  </div>

  <div class="mt-2 mb-2 fw-bold">
    List of Attended MSME Participants
  </div>

  <div class="table-responsive">
    <table mat-table
           [dataSource]="dataSource"
           class="table table-striped table-bordered table-hover"
           matSort>

      <ng-container matColumnDef="rowNum">
        <th mat-header-cell *matHeaderCellDef>SR. NO</th>
        <td mat-cell *matCellDef="let gr">{{ gr.rownum || gr.rowNum }}</td>
      </ng-container>

      <ng-container matColumnDef="udyamRegistrationNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          UDYAM REGISTRATION NUMBER
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.udyamRegistrationNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="eventDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          EVENT DATE
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.eventDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="intervention">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          INTERVENTION
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.intervention }}
        </td>
      </ng-container>

      <ng-container matColumnDef="component">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          COMPONENT
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.component }}
        </td>
      </ng-container>

      <ng-container matColumnDef="eventDistrict">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          EVENT DISTRICT
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.eventDistrict }}
        </td>
      </ng-container>

      <ng-container matColumnDef="enterpriseName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          ENTERPRISE NAME
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.enterpriseName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="designation">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          DESIGNATION
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.designation }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mobileNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          MOBILE NUMBER
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.mobileNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="emailId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          EMAIL ID
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.emailId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="attendedEventsCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          ATTENDED EVENTS COUNT
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.attendedEventsCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          STATUS
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.status }}
        </td>
      </ng-container>

      <ng-container matColumnDef="eligibilityReason">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          REMARK
        </th>
        <td mat-cell *matCellDef="let gr">
          {{ gr.eligibilityReason }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="13">
          No data matching the filter
        </td>
      </tr>

    </table>
  </div>

  <mat-paginator #paginator
                 class="demo-paginator"
                 (page)="onPageChange($event)"
                 [length]="length"
                 [pageSize]="pageSize"
                 [disabled]="disabled"
                 [showFirstLastButtons]="showFirstLastButtons"
                 [pageSizeOptions]="pageSizeOptions"
                 [hidePageSize]="hidePageSize"
                 [pageIndex]="pageIndex"
                 aria-label="Select page">
  </mat-paginator>

</div>
